import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/fermentations/$group_id/results/")({
  component: ResultsIndex,
});

function ResultsIndex() {
  const { group_id } = Route.useParams();
  const navigate = useNavigate();

  // Redirect to KPIs page
  useEffect(() => {
    navigate({
      to: "/fermentations/$group_id/results/data",
      params: { group_id },
      replace: true,
    });
  }, [group_id, navigate]);

  return null;
}

